import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import LoadingComponent from "../../common/loadingComponent";
import SessionForm from "./SessionForm";
import {getSessionByID} from "../../../../services/sessionsService";

class LoadSessionForm extends Component {

    _isMounted = false;

    state = {
        RedirectToLoginPage:false,
        isLoading : false,
        userToken : this.props.user,
        session : {},
        locale : this.props.locale
    };


    componentDidMount() {
        this._isMounted = true;

        if (this.props.id !== undefined){
            this.onLoadSession();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadSession = async () =>{
        try {
            this.setState({isLoading:true});
            const {data: session} = await getSessionByID(this.props.id);
            if (this._isMounted){
                this.setState({
                    session,
                    isLoading: false
                });
            }

        }  catch(err)  {
            if (this._isMounted){
                this.setState({isLoading: false, RedirectToLoginPage:true});
            }
        }
    }


    renderPage = () => {
        return (
          <>
              <SessionForm
                  isAdminForm = {(this.props.id)?true:false}
                  locale = {this.props.locale}
                  session = {this.state.session}
              />
          </>
        );
    }

    render() {

        if (this.state.RedirectToLoginPage) {
            const loginPage = `/${this.state.locale}/login`
            return <Redirect to={loginPage}  />
        }

        return (
            <>
                {this.state.isLoading ? <LoadingComponent/> : this.renderPage()}
            </>
        );
    }
}

export default withRouter(LoadSessionForm);
